import React, { useEffect } from 'react'

const TestimonialsPage = ({ html }) => {
  useEffect(() => {
    document.title = 'testimonials'
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <span dangerouslySetInnerHTML={{ __html: html }}></span>
    </>
  )
}

export default TestimonialsPage
